export default {
  data() {
    return {
      autoLoad: true,
      correctParams: {},
      syncParamsToUrl: false,
      dataList: [], // 统一返回的数据对象
      alias: {
        // 参数别名，保持数据应用的统一性
        dataList: 'list',
        total: 'total',
        pageNum: 'pageNo',
        pageSize: 'pageSize'
      },
      total: 0
    }
  },
  methods: {
    changeToCurrentParams(cb) {
      this.correctParams = {}   //清空correctParams:add by weil 20221017
      for (const key in this.params) {
        if (this.paramsException.includes(key)) {
        } else if (this.alias[key]) {
          this.correctParams[this.alias[key]] = this.params[key]
        } else {
          this.correctParams[key] = this.params[key]
        }
      }
      if (this.syncParamsToUrl) {
        this.$router.push({
          path: this.$route.path,
          query: this.paramsa
        })
      }
      cb && cb()
    },
    search() {
      // console.log(this.params);
      this.params.pageNum = 1
      // this.params.directId = Number(directId)
      this.getList()
    },
    gotoPage(pageNum, pageSize) {
      this.params.pageNum = parseInt(pageNum) || this.params.pageNum
      this.params.pageSize = parseInt(pageSize) || this.params.pageSize
      this.getList()
    },
    getList(pagination) {
      if(pagination){  //修复选择页面大小时的分页参数:add by weil 20221124
        this.params.pageSize = pagination.limit
        this.params.pageNo = pagination.page
      }
      if (this.beforeAction) {
        this.beforeAction()
      }
      this.changeToCurrentParams(() => {
        if (!this.api) return
        this.loading = true
        const params = this.correctParams
        console.log(params);
        
        // params[this.apiParmas] = this.correctParams
        // const params = this.correctParams
        this.api(params)
          .then(res => {
            this.loading = false
            // this.params.total = res.data && (res[this.alias['total']] || res.data[this.alias['total']])
            if (this.dataCallBack) {
              this.dataCallBack(res)
            } else if (res.code === 200 || res.status === 1200) {
              this.dataList = res[this.alias['dataList']]
            }
          })
          .catch(() => {
            this.loading = false
          })
      })
    }
  },
  mounted() {
    this.$nextTick(() => {
      // this.page = this.$route.query.page ? parseInt(this.$route.query.page) : 1;
      const query = this.$route.query
      const params = this.$route.params
      const allParams = Object.assign({}, query, params)
      // 如果路由带有参数，则实例化会 params 对象中
      for (const key in allParams) {
        this.params[key] = /^\d+$/.test(allParams[key])
          ? allParams[key]
          : allParams[key]
      }
      if (this.autoLoad) {
        this.getList()
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/mixins/getMultiList.js